import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { DICT } from "../i18n";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [lang, setLangState] = useState(() => localStorage.getItem("ssf_lang") || "en");
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({ settings: {}, hero: {}, about: {}, work_areas: [] }));
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)).finally(() => setAuthChecked(true));
  }, []);

  const setLang = useCallback((l) => {
    localStorage.setItem("ssf_lang", l);
    setLangState(l);
  }, []);

  const t = useCallback((key) => DICT[lang]?.[key] ?? DICT.en[key] ?? key, [lang]);
  const L = useCallback((obj, field) => {
    if (!obj) return "";
    if (lang === "hi" && obj[`${field}_hi`]) return obj[`${field}_hi`];
    return obj[field] ?? obj[`${field}_en`] ?? "";
  }, [lang]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  }, []);

  return (
    <AppCtx.Provider value={{ user, setUser, authChecked, lang, setLang, t, L, site, setSite, logout }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
